import { motion } from 'framer-motion';

// Balancing - станок для балансировки колёс
const BalancingIcon = () => (
  <svg viewBox="0 0 80 80" className="w-14 h-14 lg:w-20 lg:h-20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Станина/база */}
    <rect x="10" y="65" width="60" height="8" rx="2" stroke="#FF2E2E" strokeWidth="2"/>
    {/* Стойка */}
    <rect x="18" y="30" width="8" height="35" stroke="#FF2E2E" strokeWidth="2"/>
    {/* Панель управления */}
    <rect x="12" y="35" width="20" height="18" rx="2" stroke="#FF2E2E" strokeWidth="2"/>
    <circle cx="17" cy="44" r="2" fill="#FF2E2E"/>
    <circle cx="22" cy="44" r="2" fill="#FF2E2E"/>
    <circle cx="27" cy="44" r="2" fill="#FF2E2E"/>
    <rect x="15" y="38" width="12" height="3" fill="#FF2E2E"/>
    {/* Вал/ось */}
    <line x1="26" y1="48" x2="55" y2="48" stroke="#FF2E2E" strokeWidth="3"/>
    {/* Колесо на станке */}
    <circle cx="55" cy="48" r="18" stroke="#FF2E2E" strokeWidth="2.5"/>
    <circle cx="55" cy="48" r="12" stroke="#FF2E2E" strokeWidth="2"/>
    <circle cx="55" cy="48" r="5" fill="#FF2E2E"/>
    {/* Крепление */}
    <circle cx="55" cy="48" r="3" stroke="#FF2E2E" strokeWidth="1.5" fill="none"/>
  </svg>
);

// Tire Change - круговые стрелки
const TireChangeIcon = () => (
  <svg viewBox="0 0 80 80" className="w-14 h-14 lg:w-20 lg:h-20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Колесо в центре */}
    <circle cx="40" cy="40" r="18" stroke="#FF2E2E" strokeWidth="2.5"/>
    <circle cx="40" cy="40" r="12" stroke="#FF2E2E" strokeWidth="2"/>
    <circle cx="40" cy="40" r="5" fill="#FF2E2E"/>
    {/* Круговая стрелка 1 (верхняя правая) */}
    <path d="M58 25 A25 25 0 0 1 65 45" stroke="#FF2E2E" strokeWidth="3" strokeLinecap="round" fill="none"/>
    <polygon points="68,42 65,50 60,43" fill="#FF2E2E"/>
    {/* Круговая стрелка 2 (нижняя левая) */}
    <path d="M22 55 A25 25 0 0 1 15 35" stroke="#FF2E2E" strokeWidth="3" strokeLinecap="round" fill="none"/>
    <polygon points="12,38 15,30 20,37" fill="#FF2E2E"/>
  </svg>
);

// Storage - гараж/склад
const StorageIcon = () => (
  <svg viewBox="0 0 80 80" className="w-14 h-14 lg:w-20 lg:h-20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Крыша */}
    <path d="M5 32 L40 8 L75 32" stroke="#FF2E2E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Стены */}
    <path d="M10 32 L10 70 L70 70 L70 32" stroke="#FF2E2E" strokeWidth="2.5" fill="none"/>
    {/* Ворота */}
    <rect x="20" y="40" width="40" height="30" stroke="#FF2E2E" strokeWidth="2" fill="none"/>
    {/* Секции ворот */}
    <line x1="20" y1="48" x2="60" y2="48" stroke="#FF2E2E" strokeWidth="1.5"/>
    <line x1="20" y1="56" x2="60" y2="56" stroke="#FF2E2E" strokeWidth="1.5"/>
    <line x1="20" y1="64" x2="60" y2="64" stroke="#FF2E2E" strokeWidth="1.5"/>
    {/* Ручка */}
    <rect x="55" y="52" width="3" height="6" fill="#FF2E2E"/>
  </svg>
);

// TPMS Sensors - датчик давления
const TPMSIcon = () => (
  <svg viewBox="0 0 80 80" className="w-14 h-14 lg:w-20 lg:h-20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Корпус датчика */}
    <rect x="25" y="20" width="30" height="45" rx="4" stroke="#FF2E2E" strokeWidth="2.5"/>
    {/* Экран */}
    <rect x="30" y="26" width="20" height="12" rx="1" stroke="#FF2E2E" strokeWidth="1.5"/>
    {/* Показания на экране */}
    <text x="33" y="35" fill="#FF2E2E" fontSize="8" fontWeight="bold">32</text>
    <text x="46" y="35" fill="#FF2E2E" fontSize="5">PSI</text>
    {/* Кнопки */}
    <circle cx="35" cy="48" r="3" stroke="#FF2E2E" strokeWidth="1.5"/>
    <circle cx="45" cy="48" r="3" stroke="#FF2E2E" strokeWidth="1.5"/>
    {/* Антенна/вентиль */}
    <rect x="38" y="10" width="4" height="10" rx="1" fill="#FF2E2E"/>
    <circle cx="40" cy="8" r="3" stroke="#FF2E2E" strokeWidth="1.5"/>
    {/* Сигнал */}
    <path d="M55 15 C60 20 60 28 55 33" stroke="#FF2E2E" strokeWidth="2" strokeLinecap="round" fill="none"/>
    <path d="M60 12 C68 20 68 32 60 38" stroke="#FF2E2E" strokeWidth="2" strokeLinecap="round" fill="none"/>
    {/* Индикатор */}
    <circle cx="40" cy="58" r="4" fill="#FF2E2E"/>
  </svg>
);

// Tire Repair - залатанное колесо
const RepairIcon = () => (
  <svg viewBox="0 0 80 80" className="w-14 h-14 lg:w-20 lg:h-20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Колесо */}
    <circle cx="40" cy="40" r="32" stroke="#FF2E2E" strokeWidth="2.5"/>
    <circle cx="40" cy="40" r="24" stroke="#FF2E2E" strokeWidth="3"/>
    <circle cx="40" cy="40" r="14" stroke="#FF2E2E" strokeWidth="2"/>
    <circle cx="40" cy="40" r="6" fill="#FF2E2E"/>
    {/* Болты */}
    <circle cx="40" cy="30" r="2" fill="#FF2E2E"/>
    <circle cx="48" cy="35" r="2" fill="#FF2E2E"/>
    <circle cx="48" cy="45" r="2" fill="#FF2E2E"/>
    <circle cx="40" cy="50" r="2" fill="#FF2E2E"/>
    <circle cx="32" cy="45" r="2" fill="#FF2E2E"/>
    <circle cx="32" cy="35" r="2" fill="#FF2E2E"/>
    {/* Латка/пластырь - крестообразный */}
    <rect x="54" y="18" width="16" height="8" rx="1" fill="#FF2E2E"/>
    <rect x="60" y="12" width="4" height="20" rx="1" fill="#FF2E2E"/>
    {/* Точки на латке */}
    <circle cx="57" cy="22" r="1" fill="#0a0a0a"/>
    <circle cx="67" cy="22" r="1" fill="#0a0a0a"/>
    <circle cx="62" cy="15" r="1" fill="#0a0a0a"/>
    <circle cx="62" cy="29" r="1" fill="#0a0a0a"/>
  </svg>
);

// Oil Change - масляная лампа индикатор
const OilChangeIcon = () => (
  <svg viewBox="0 0 80 80" className="w-14 h-14 lg:w-20 lg:h-20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Масленка/лампа Аладдина */}
    <ellipse cx="40" cy="55" rx="25" ry="10" stroke="#FF2E2E" strokeWidth="2.5"/>
    <path d="M15 55 Q15 35 30 35 L50 35 Q65 35 65 55" stroke="#FF2E2E" strokeWidth="2.5" fill="none"/>
    {/* Носик */}
    <path d="M65 45 L75 38 L75 42 L68 48" stroke="#FF2E2E" strokeWidth="2.5" fill="none"/>
    {/* Ручка */}
    <path d="M15 45 Q5 45 5 35 Q5 25 15 25" stroke="#FF2E2E" strokeWidth="2.5" fill="none"/>
    {/* Капля масла */}
    <path d="M72 48 Q75 55 72 60 Q69 55 72 48" fill="#FF2E2E"/>
    {/* Крышка */}
    <ellipse cx="40" cy="35" rx="8" ry="3" stroke="#FF2E2E" strokeWidth="2"/>
    <rect x="36" y="25" width="8" height="10" stroke="#FF2E2E" strokeWidth="2"/>
  </svg>
);

// Brake Pads - тормозные колодки
const BrakePadsIcon = () => (
  <svg viewBox="0 0 80 80" className="w-14 h-14 lg:w-20 lg:h-20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Тормозной диск */}
    <circle cx="40" cy="40" r="28" stroke="#FF2E2E" strokeWidth="2.5"/>
    <circle cx="40" cy="40" r="20" stroke="#FF2E2E" strokeWidth="2"/>
    <circle cx="40" cy="40" r="10" stroke="#FF2E2E" strokeWidth="2"/>
    {/* Вентиляционные отверстия диска */}
    <circle cx="40" cy="26" r="2" fill="#FF2E2E"/>
    <circle cx="52" cy="32" r="2" fill="#FF2E2E"/>
    <circle cx="52" cy="48" r="2" fill="#FF2E2E"/>
    <circle cx="40" cy="54" r="2" fill="#FF2E2E"/>
    <circle cx="28" cy="48" r="2" fill="#FF2E2E"/>
    <circle cx="28" cy="32" r="2" fill="#FF2E2E"/>
    {/* Тормозной суппорт/колодка */}
    <path d="M58 25 L72 20 L74 35 L72 50 L58 55 L58 25" stroke="#FF2E2E" strokeWidth="2.5" fill="none"/>
    {/* Поршни суппорта */}
    <rect x="62" y="30" width="6" height="5" fill="#FF2E2E"/>
    <rect x="62" y="40" width="6" height="5" fill="#FF2E2E"/>
    {/* Болты крепления */}
    <circle cx="65" cy="23" r="2" fill="#FF2E2E"/>
    <circle cx="65" cy="52" r="2" fill="#FF2E2E"/>
  </svg>
);

const services = [
  {
    icon: TireChangeIcon,
    title: 'Tire Change',
    description: 'Professional tire mounting and dismounting service. All sizes from compact cars to trucks.',
  },
  {
    icon: BalancingIcon,
    title: 'Balancing',
    description: 'Precision wheel balancing ensures smooth rides and extends tire life. State-of-the-art equipment.',
  },
  {
    icon: OilChangeIcon,
    title: 'Oil Change',
    description: 'Quick and professional oil change service. We use quality oils for all vehicle types.',
  },
  {
    icon: BrakePadsIcon,
    title: 'Brake Pads',
    description: 'Brake pad replacement and brake system inspection. Your safety is our priority.',
  },
  {
    icon: TPMSIcon,
    title: 'TPMS Sensors',
    description: 'Tire Pressure Monitoring System installation, repair, and programming.',
  },
  {
    icon: RepairIcon,
    title: 'Tire Repair',
    description: 'Expert puncture repair and tire patching services. Reliable fixes for your tires.',
  },
  {
    icon: StorageIcon,
    title: 'Storage',
    description: 'Secure seasonal tire storage. Climate-controlled environment protects your investment.',
  },
];

export const Services = () => {
  return (
    <section id="services" className="py-16 lg:py-24 bg-[#0a0a0a] relative" data-testid="services-section">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#FF2E2E]/50 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10 lg:mb-16"
        >
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-6xl text-white mb-4" data-testid="services-title">
            Our Services
          </h2>
          <p className="font-body text-white/60 text-base lg:text-lg max-w-2xl mx-auto px-4">
            Professional tire services with precision and care. Quality work, competitive prices.
          </p>
          <div className="w-16 lg:w-24 h-1 bg-[#FF2E2E] mx-auto mt-4 lg:mt-6" />
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-[#111111] border border-[#FF2E2E]/30 hover:border-[#FF2E2E] p-6 lg:p-10 text-center transition-all duration-300 group"
              data-testid={`service-card-${index}`}
            >
              <div className="flex items-center justify-center mb-4 lg:mb-6 group-hover:scale-110 transition-transform duration-300">
                <service.icon />
              </div>
              <h3 className="font-heading text-lg lg:text-2xl text-white mb-2 lg:mb-4">{service.title}</h3>
              <p className="font-body text-white/50 text-xs lg:text-sm leading-relaxed hidden sm:block">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
